module.exports = __webpack_public_path__ + "img/ddlogo.7cc58b75.png";